import type { ReactNode } from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import { MHMLogoCheckbox, type MHMLogoCheckboxProps } from './MHMLogoCheckbox';

type Props<T extends typeof MuiCheckbox> = {
  Checkbox?: T;
  checkboxProps: MHMLogoCheckboxProps;
  label: ReactNode;
};

export const MHMLabelledCheckbox = <T extends typeof MuiCheckbox>(
  props: Props<T>,
) => {
  const { Checkbox = MHMLogoCheckbox, label, checkboxProps } = props;
  return (
    <FormControlLabel label={label} control={<Checkbox {...checkboxProps} />} />
  );
};
